<input 
  #inputRef
  type="text"
  [disabled]="disabled"
  pInputText
  [(ngModel)]="value"
  [ngClass]="isValid? 'ng-valid' : 'ng-invalid ng-dirty p-inputtext-invalid'"
  (blur)="onBlur($event)"
  (keypress)="omitIllegalCharacters($event)"
  (paste)="omitIllegalCharactersOnPaste($event)"
  (keyup)="onKeyUp($event)"
/>
